export class EnumerationValue {
  constructor(id, key, t = undefined) {
    this.id = id;
    this.key = key;
    this.label = t ? t(key) : key;
  }

  get fullDesignation() {
    return this.label;
  }

  get fastModeBrowserDesignation() {
    return this.label;
  }
}

export class Enumeration {
  static getEnumValues(enumType, translateFn) {
    const values = this[enumType] ?? [];
    return values.map((v) => new EnumerationValue(v.id, v.key, translateFn));
  }

  static getEnumValue(enumType, enumValueOrObject, translateFn = undefined) {
    const values = this[enumType] ?? [];
    const valueToUse =
      typeof enumValueOrObject === 'string'
        ? enumValueOrObject
        : enumValueOrObject?.id;
    const val = values.find((v) => v.id === valueToUse);
    return val ? new EnumerationValue(val.id, val.key, translateFn) : undefined;
  }
}
